import api from "../utils/axiosInstance";

const API = "USER";

export const addBankDetail = async (data) => {
    try {
        const response = await api.post(`/${API}/bank/add`, data);
        return response;
    } catch (error) {
        return error;
    }
};

export const updateBankDetail = async (data) => {
    try {
        const response = await api.post(`/${API}/bank/update`, data);
        return response;
    } catch (error) {
        return error;
    }
};